import { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../api';

const AdminUserContext = createContext(null);

// Decode JWT payload without verification (for UI only — server still verifies)
function decodeToken(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return {
      id: payload.id,
      username: payload.username,
      role: payload.role || 'admin',
      allowedLangs: Array.isArray(payload.allowedLangs) ? payload.allowedLangs : [],
    };
  } catch {
    return null;
  }
}

export function AdminUserProvider({ children }) {
  const token = localStorage.getItem('admin_token');
  // Seed user immediately from token so components never wait for a network call
  const [user, setUser] = useState(() => (token ? decodeToken(token) : null));

  useEffect(() => {
    if (!token) { setUser(null); return; }
    // Refresh from DB to pick up any role/allowedLangs changes made since login
    api.getMe()
      .then((fresh) => setUser({ ...fresh, allowedLangs: Array.isArray(fresh.allowedLangs) ? fresh.allowedLangs : [] }))
      .catch(() => { /* keep the token-decoded value */ });
  }, []); // eslint-disable-line

  return (
    <AdminUserContext.Provider value={{ user, setUser }}>
      {children}
    </AdminUserContext.Provider>
  );
}

export function useAdminUser() {
  return useContext(AdminUserContext);
}
